<template>
  <div>
    <div class="mask" v-if="show_street" @click="show_street = !show_street"></div>
    <div class="area-window" v-if="show_street">
      <div class="window-btn">
        <div class="cancel-btn" @click="cancelWindow">取消</div>
        <div class="confirm-btn" @click="confirmChoose">确定</div>
      </div>
      <div class="area-container">
        <div class="street-list">
          <div class="street-item" :class="street_idx == k ? 'active' : ''" v-for="(i, k) in street_list"
            @click="chooseStreet(k)">{{ i.title }}</div>
        </div>
        <div class="comm-list">
          <div class="comm-item" :class="comm_idx == k ? 'active' : ''" v-for="(i, k) in comm_list"
            @click="chooseComm(k)">
            {{ i.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getFulianCate } from "@api/public";
export default {
  name: "AreaPicker",
  props: {

  },
  inject: ['app'],
  data: function () {
    return {
      street_list: [], //街道列表
      comm_list: [],//社区列表
      street_idx: 0, //街道下标
      comm_idx: 0, //社区下标
      street_id: 0, //街道id
      comm_id: 0, //社区id
      street_str:'',
      show_street: false
    };
  },
  mounted() {
    this.getFulianCate();
  },
  methods: {
    showArea(){
      this.show_street = !this.show_street;
    },
    getFulianCate: function () {
      let that = this;
      let pid = 8;
      getFulianCate(pid).then((res) => {
        let list = res.data;
        that.$set(that, "street_list", list);
        that.$set(that, "comm_list", list[0].children);

        // this.confirmChoose()
      });
    },

    chooseStreet(index) {
      let list = this.street_list,
        choose_item = list[index];
      this.street_idx = index;

      this.comm_idx = 0;
      this.comm_list = choose_item.children;
    },
    chooseComm(index) {
      let list = this.comm_list;
      this.comm_idx = index;
    },

    cancelWindow() {
      let street_list = this.street_list,
        street_id = this.street_id,
        comm_id = this.comm_id;
      for (let i in street_list) {
        let item = street_list[i];
        console.log(item.id, street_id)
        if (item.id == street_id) {
          let comm_list = item.children;
          this.comm_list = comm_list;
          this.street_idx = i;

          for (let j in comm_list) {
            let comm = comm_list[j]
            if (comm.id == comm_id) {
              this.comm_idx = j
              break
            }
          }
          break
        }
      }
      this.show_street = false
    },
    confirmChoose() {
      let street_list = this.street_list,
        comm_list = this.comm_list,
        street_idx = this.street_idx,
        comm_idx = this.comm_idx;
      this.street_id = street_list[street_idx].id;
      this.comm_id = comm_list[comm_idx].id;
      this.street_str = `${street_list[street_idx].title} ${comm_list[comm_idx].title}`;
      this.show_street = false;
      this.$emit('chooseArea',{
        street_idx:this.street_idx,
        comm_idx:this.comm_idx,
        street_id:this.street_id,
        comm_id:this.comm_id,
        street_str:this.street_str
      })
    },
    goPage(url) {
      this.$router.push({ path: url });
    }
  }
};
</script>
<style scoped lang="scss">
.area-window {
  position: fixed;
  left: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 556;
  width: 100vw;
  height: 50%;

  .window-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: .3rem;
    font-size: .3rem;
    line-height: 1;
    border-bottom: 1px solid #EFEFEF;
    font-size: .3rem;

    .cancel-btn {}

    .confirm-btn {
      color: #F64272;
    }
  }

  .area-container {
    height: calc(50vh - 0.9rem);
    display: flex;

    .street-list {
      min-width: 2.77rem;
      background-color: #EFEFEF;
      flex-shrink: 0;
      height: 100%;
      overflow-y: auto;

      .street-item {
        line-height: 1rem;
        text-align: center;
        font-size: .3rem;

        &.active {
          background-color: #fff;
          color: #F64272;
        }
      }
    }

    .comm-list {
      flex: 1;
      padding-left: .5rem;
      height: 100%;
      overflow-y: auto;

      .comm-item {
        padding: .25rem 0;
        font-size: .3rem;
        line-height: 1;

        &.active {
          color: #F64272;
        }
      }
    }
  }
}
</style>
